function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React, { useEffect, useLayoutEffect } from 'react';
import i18n from '@pureartisan/simple-i18n';
import clsx from 'clsx';
import { MdClose } from 'react-icons/md';
import useStore from './../store.js';
import PanelFilterView from './../PanelFilterView/PanelFilterView';
import PanelLayersView from './../PanelLayersView/PanelLayersView';
import PanelInfoView from './../PanelInfoView/PanelInfoView';
import PanelLocationView from './../PanelLocationView';
import { CoreButton } from './../../../core';
import { setFocus } from '../utils.js';

var SlideoutPanel = function SlideoutPanel(_ref) {
  var props = _extends({}, _ref); // Generic store value setter.


  var setStoreValues = useStore(function (state) {
    return state.setStoreValues;
  });
  var slideoutPanel = useStore(function (state) {
    return state.slideoutPanel;
  });
  var activePanel = slideoutPanel.active && slideoutPanel.panel;

  var handleLocationClose = function handleLocationClose(event) {
    // clear active location when closing panel
    handleClose(event, {
      activeFeature: 0
    });
  };

  var handleClose = function handleClose(event, stateChanges) {
    if (stateChanges === void 0) {
      stateChanges = {};
    } // Set focus on the clicked button.


    var panelBtnId = '#button_toggle_panel_' + activePanel;
    setFocus(panelBtnId); // Update store.

    setStoreValues(_extends({
      slideoutPanel: _extends({}, slideoutPanel, {
        active: false
      })
    }, stateChanges));
  };

  var isPanelOpen = function isPanelOpen(panelId) {
    return activePanel === panelId && slideoutPanel.active;
  }; // set focus to first button in panel when it opens


  useLayoutEffect(function () {
    if (!activePanel) return; // add short timeout so the `visibility` prop on the panel
    // is set to `visible` (otherwise, no focus)

    setTimeout(function () {
      return setFocus("#panel_" + activePanel);
    }, 1);
  }, [activePanel]);
  return /*#__PURE__*/React.createElement("div", {
    className: "map-panel-slideout"
  }, /*#__PURE__*/React.createElement(PanelFilterView, {
    id: "panel_filters",
    tabIndex: "-1",
    open: isPanelOpen('filters'),
    "aria-hidden": !isPanelOpen('filters'),
    onClose: handleClose
  }), /*#__PURE__*/React.createElement(PanelLayersView, {
    id: "panel_layers",
    tabIndex: "-1",
    open: isPanelOpen('layers'),
    onClose: handleClose
  }), /*#__PURE__*/React.createElement(PanelLocationView, {
    id: "panel_location",
    tabIndex: "-1",
    open: isPanelOpen('location'),
    onClose: handleLocationClose
  }), /*#__PURE__*/React.createElement(PanelInfoView, {
    id: "panel_info",
    tabIndex: "-1",
    open: isPanelOpen('info'),
    onClose: handleClose
  }));
};

export default SlideoutPanel;